var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditing || _vm.isVisible)?_c('section',{staticClass:"base-module",class:{ 'transition-overflow': _vm.transition },style:({
    '--bg-color': _vm.backgroundColor,
    '--title-color': _vm.titleColor,
    '--title-weight': _vm.titleWeight,
    '--text-color': _vm.textColor,
    '--title-size-desk': `${_vm.titleSizeDesk}px`,
    '--content-size-desk': `${_vm.contentSizeDesk}px`,
    '--title-size-mobile': `${_vm.titleSizeMobile}px`,
    '--content-size-mobile': `${_vm.contentSizeMobile}px`,
    '--button-color': _vm.buttonColor,
    '--button-text-color': _vm.buttonTextColor,
    '--padding-top': _vm.paddingTop + 'px',
    '--padding-bottom': _vm.paddingBottom + 'px',
    '--padding-top-mobile': _vm.paddingTopMobile + 'px',
    '--padding-bottom-mobile': _vm.paddingBottomMobile + 'px',
  }),attrs:{"id":`${_vm.$parent.$options.name}-${_vm.instanceId}`,"data-module":_vm.dataModule}},[_c('div',{ref:"aosWrapper"},[_vm._t("default")],2),_vm._t("modal")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }